<template>
  <div class="player">
    <div class="header">
      <div style="flex:1;text-align: left;">
        <img src="@/assets/img/drillCenter/logo.png"
             @click="back"
             style="cursor: pointer; width: 140px;margin-top: 10px;"
             alt="">

      </div>

      <h1 style="flex:1;margin-top:0"
          class="top-left"></h1>

      <the-now-time style="flex:1"></the-now-time>

    </div>
    <el-row style="flex: 1;display:flex;"
            >
      <div style="padding-left:20px;    display: flex; align-items: center;"  >
               <ckplayer-only
               
        :ckplayerDialogShow="false"
        :isLive="false"
        :videoUrl="info.cloudMeetingLivePlayback"
        :widthHeigt="[1380,700]"
      ></ckplayer-only>
        <!-- <video :src="videoUrl"
               width="100%"
               controlsList="nodownload"
               height="auto"
               style="height:calc(100vh - 160px) "
               controls
               autoplay></video> -->
      </div>
      <el-col :span="6"
              class="right">
        <h2>{{ info.cloudMeetingName }}</h2>
        <img :src="$store.state.config.fileUrl+info.cloudMeetingCover"
             alt="">
        <div class="content">
          {{ info.cloudMeetingContent }}

        </div>
      </el-col>

    </el-row>
    <!-- <div id="player-container-id" width="100%" height="100%" preload="auto" playsinline webkit-playsinline></div> -->
  </div>
</template>

<script>
import { error } from 'highcharts';
import TheNowTime from "./components/theNowTime.vue";
import CkplayerOnly from "@/components/CkplayerOnly";
// import cos from 'cos-js-sdk-v5'; // 通过 npm 安装的 SDK
export default {
  name: "TcPlayerUnit",
  components: { TheNowTime,CkplayerOnly },
  props: {

  },
  data () {
    return {
      player: "",
      info: {},
      url: "",
      videoUrl: ""
    };
  },
  created () {



  },
  mounted () {
    this.info = JSON.parse(this.$route.query.info)
    this.url = this.info.cloudMeetingStatus == 1 ? this.info.cloudMeetingLiveAddress : this.info.cloudMeetingLivePlayback
    console.log(this.info)
    // this.$Common.getPlayUrl(this.info.cloudMeetingLivePlayback).then(res=>{
    //  
    // }).catch(err=>{
    //   this.$message.error(err)
    // })
    // this.play(url);
  },
  watch: {
    playVideo: function (newVal) {
      // console.log(newVal);
      this.play();
    }
  },
  methods: {
    
    back () {
      this.$router.go(-1)
    },
    videoError () {
      console.log('error')
    },
    play (url) {
      let dom = document.getElementById("player-container-id");
      while (dom.hasChildNodes()) {
        // 当存在子节点时 销毁视频
        this.player.destroy();
      }
      // console.log(dom);
      // console.log("tcplayer" + this.index);
      this.player = new WasmPlayer(null, "player-container-id", this.callbackfun, {
        openAudio: false
      })
      this.player.play(url, 1)
      // console.log(this.playVideo,'this.playVideo')
      // this.player = new this.TcPlayer("tcplayer" + this.index, {
      //   m3u8_sd: this.playVideo.m3u8_sd, //请替换成实际可用的播放地址
      //   m3u8_hd: this.playVideo.m3u8_hd,
      //   // flv_sd: this.playVideo.flv_sd, //请替换成实际可用的播放地址
      //   // flv_hd: this.playVideo.flv_hd, //请替换成实际可用的播放地址
      //   autoplay: true, //iOS 下 safari 浏览器，以及大部分移动端浏览器是不开放视频自动播放这个能力的
      //   // poster: "http://www.test.com/myimage.jpg",
      //   flash: false,
      //   h5_flv: true,
      //   width: this.widthHeigt[0] + "px", //视频的显示宽度，请尽量使用视频分辨率宽度
      //   height: this.widthHeigt[1] + "px", //视频的显示高度，请尽量使用视频分辨率高度
      //   live: true,
      //   volume: 0,
      //   clarity: "sd",
      //   wording: {
      //     2: "摄像头连接网络不稳定",
      //     1002: "摄像头连接网络不稳定，请切换清晰度"
      //   }
      // });

    }
  },
  destroyed () {
    // 页面销毁，同时也销毁 TcPlayer
    // this.player.destroy();
  },
  callbackfun (e) {
    console.log(e)
  },

  //   play(address) {

  //     // console.log(dom);
  //     // console.log("tcplayer" + this.index);
  //     this.player = TCPlayer("player-container-id",
  //         {
  //             sources: [{
  //             src: address, // 
  //             }],
  //             licenseUrl: 'license/url', // 

  //         }
  //     );
  //   }
  // },
  // destroyed() {
  //   // 页面销毁，同时也销毁 TcPlayer
  //   // this.player.destroy();
  // }
};
</script>
<style lang="scss" scoped>
.player {
  width: 100%;
  height: 100%;
  color: #fff;
  background-image: url('~@/assets/img/drillCenter/contentbg.jpg');
  padding: 0 30px 30px;
  background-size: 100% 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .right {
    padding: 0 20px 10px;
    flex: 1;
    height: 100%;
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: space-between;
    h2 {
      border: 1px solid rgba(0, 174, 255, 0.42);
      height: 60px;
      margin-top: 0;
      line-height: 60px;
      border-radius: 10px;
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    img {
      height: 200px;
      width: 100%;
      border-radius: 20px;
    }
  }
}
.header {
  background-image: url('~@/assets/img/drillCenter/header1.png');
  background-size: 1078px 77px;
  height: 77px;
  background-repeat: no-repeat;
  background-position: center center;
  justify-content: space-between;
  display: flex;
  align-items: center;
  padding-top: 10px;
  text-align: center;
  margin-bottom: 50px;
  padding: 0 20px;
  img {
    height: auto;
    width: 140px !important;
  }
}
.content {
  border: 1px solid rgba(0, 174, 255, 0.42);
  flex: 1;
  padding: 20px;
  line-height: 1.5;
  font-size: 20px;
  margin: 20px 0 0 0;
  border-radius: 10px;
}
</style>